module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/bonus-pict-19a7f9a3511d8ee919d7002f182e1fda.jpg";